// utils/colors.js

export const getPriorityColor = (priority) => {
    switch (priority) {
        case "HIGH":
            return "bg-red-100 text-red-800";
        case "MEDIUM":
            return "bg-yellow-100 text-yellow-800";
        case "LOW":
            return "bg-green-100 text-green-800";
        default:
            return "bg-gray-100 text-gray-800";
    }
};

export const getStatusColor = (status) => {
    switch (status) {
        case "Active":
            return "bg-green-100 text-green-800";

        case "Inactive":
            return "bg-red-100 text-red-800";

        case "Pending":
        case "PENDING":
        case "IN_PROGRESS":
        case "IN_REVIEW":
        case "Review":
            return "bg-yellow-100 text-yellow-800";

        case "Completed":
        case "COMPLETED":
        case "CLOSED":
            return "bg-green-100 text-green-800";

        case "In Progress":
            return "bg-blue-100 text-blue-800";

        case "Blocked":
        case "OVERDUE":
            return "bg-red-100 text-red-800";

        case "NOT_STARTED":
        case "TODO":
        case "Draft":
            return "bg-gray-100 text-gray-800";

        case "Archived":
            return "bg-red-100 text-red-800";

        case "PROPOSED":
            return "bg-purple-100 text-purple-800";

        default:
            return "bg-gray-100 text-gray-800";
    }
};

